export default {
  title: "Manažerský dashboard",
  backToAdmin: "Zpět na Admin Dashboard",
  backToManagerDashboard: "Zpět na Manažerský panel",
  allDates: "Všechna data",
  selectGroups: "Vyberte skupiny",
  groups: "Skupiny",
  noGroups: "Žádné dostupné skupiny",
  selectGroupsPlaceholder: "Vyberte skupiny pro zobrazení",
  searchGroups: "Hledat skupiny...",
  noGroupsSelected: "Nejsou vybrány žádné skupiny",
  noDataAvailable: "Žádná data k zobrazení",
  loading: "Načítání...",
  manager: "Manažer",

  infoTitles: {
    members: "Členové",
    lessons: "Kurzy",
    completionPercentage: "Procento dokončení kurzu",
    score: "Skóre kurzu",
  },

  tabs: {
    lessons: "Kurzy",
    members: "Členové",
  },

  table: {
    member: "Jméno",
    name: "Name",
    learningPath: "Vzdělávací kurz",
    completion: "Dokončení",
    score: "Skóre",
    sortBy: "Seřadit podle",
    notStarted: "Nezahájeno",
  },

  members: {
    noMembers: "Žádní členové k zobrazení",
    emptyStateTitle: "Nebyli nalezeni žádní členové",
    emptyStateDescription: "Ve vybraných skupinách nejsou žádní členové nebo zatím nejsou k dispozici žádná data o výkonu.",
    overallCompletion: "Celkové dokončení",
    overallScore: "Celkové skóre",
    pathsProgress: "Postup v kurzech",
    pathsCompleted: "Dokončené kurzy",
    pathsStarted: "Zahájené kurzy",
  },

  insights: {
    title: "Přehledy",
    membersTab: "Members",
    insightsTab: "Insights",
    problemAreas: "Problémové oblasti",
    recommendedActions: "Doporučené akce",
    close: "Zavřít",
    noInsights: "Vyberte člena pro zobrazení přehledů",
    scoreBreakdown: "Rozpad skóre",
    gymShort: "Krátká posilovna",
    gymLong: "Dlouhá posilovna",
    challenge: "Modelová situace",
    weight: "Váha",
    games: "her",
    journeyStatus: "Stav kurzu",
    completed: "Dokončeno",
    inProgress: "Probíhá",
    noAnalysis: "Žádná analýza není k dispozici",
    notStarted: "Nezahájeno",
    viewDetails: "Zobrazit podrobnosti",
  },

  userDetail: {
    title: "Výkon uživatele",
    overallProgress: "Celkový pokrok",
    noLessons: "Žádné kurzy nejsou k dispozici",
    noData: "Žádná data k zobrazení",
    assignedLessons: "Přiřazené kurzy",
    noAssignedLessons: "Žádné přiřazené kurzy",
    score: "Skóre",
    completion: "Dokončení",
    totalTimeSpent: "Celkový čas",
    gyms: "Cvičení",
    challenges: "Modelovky",
    latestActivity: "Poslední aktivita",
    noRecentActivity: "Žádná nedávná aktivita",
    loadingActivity: "Načítání...",
    recentJourneys: "Nedávné kurzy",
    recentGames: "Nedávné hry",
    journeyFallback: "Kurz #{id}",
    gameFallback: "Hra #{id}",
    addNote: "Přidat poznámku",
    managerNotes: "Moje poznámky",
    noteTextPlaceholder: "Napište poznámku...",
    noNotes: "Zatím žádné poznámky",
    deleteNote: "Smazat poznámku",
    cancel: "Zrušit",
    completionPercentage: "Dokončení",
    averageScore: "Průměrné skóre",
    averageScoreTooltip: "Jedná se o vážený průměr, každý typ hry má jinou váhu při výpočtu celkového skóre.",
    steps: "Kroků",
    chapters: "kapitoly",
    analysisDetail: "Detail analýzy",
    conversation: "Konverzace",
    noMessages: "V této hře nejsou žádné zprávy",
    messageCount: "{count} zpráva | {count} zprávy | {count} zpráv",
    lastSignIn: "Poslední přihlášení",
    latest: "Nejnovější",
    version: "Verze",
    startedAt: "Započato",
    saving: "Ukládání...",
    playthroughOption: "#{number} - {date}",
    collapsePanel: "Sbalit panel",
    expandPanel: "Rozbalit panel",

    activityTypes: {
      journey: "kurz",
      game: "hra",
    },

    activityTime: {
      justNow: "Právě teď - {type}",
      justNowShort: "Právě teď",
      minutesAgo: "Před {minutes} minutou - {type} | Před {minutes} minutami - {type}",
      minutesAgoShort: "Před {minutes}m",
      hoursAgo: "Před {hours} hodinou - {type} | Před {hours} hodinami - {type}",
      hoursAgoShort: "Před {hours}h",
      yesterday: "Včera - {type}",
      yesterdayShort: "Včera",
      daysAgo: "Před {days} dny - {type}",
      daysAgoShort: "Před {days}d",
    },

    tabs: {
      feedback: "Zpětná vazba",
      sales: "Prodej",
      coldCalling: "Cold calling",
    },

    pills: {
      feedback: "Kategorie",
      management: "Podkategorie",
    },

    table: {
      name: "Název",
      type: "Typ",
      status: "Stav",
      played: "Odehráno",
      timeSpent: "Strávený čas",
      lastScored: "Poslední skóre",
    },

    playthrough: "Průchod",
  },

  emptyState: {
    title: "Nejsou vybrány žádné skupiny",
    description: "Vyberte jednu nebo více skupin pro zobrazení dat o výkonu a přehledů.",
    cta: "Vybrat skupiny",
  },

  messages: {
    noData: "Žádná data k zobrazení",
    fetchError: "Chyba při načítání dat",
    noPermission: "Nemáte oprávnění k zobrazení těchto dat",
  },

  mutualAgreements: {
    title: "Dohody & Úkoly",
    add: "Přidat",
    createAgreement: "Vytvořit dohodu/úkol",
    editAgreement: "Upravit dohodu/úkol",
    viewAgreement: "Detail dohody/úkolu",
    noAgreements: "Zatím žádné vzájemné dohody/úkoly",
    confirmDelete: "Opravdu chcete smazat tuto dohodu/úkol?",
    markComplete: "Označit jako splněno",
    markIncomplete: "Označit jako nesplněno",
    fulfilledOn: "Splněno {date}",
    overdue: "⚠ Po termínu",
    save: "Uložit",
    create: "Vytvořit",
    saving: "Ukládám...",
    modalTitle: "Název dohody/úkolu",
    status: "Stav",
    statusFulfilled: "Splněno",
    statusPending: "Čeká na splnění",

    // Form fields
    titlePlaceholder: "Zadejte název dohody/úkolu...",
    description: "Popis",
    descriptionPlaceholder: "Popište detaily dohody/úkolu...",
    dueDate: "Termín splnění",

    // Priority
    priority: "Priorita",
    priorityLow: "Nízká",
    priorityMedium: "Střední",
    priorityHigh: "Vysoká",

    // Categories
    category: "Kategorie",
    categoryGeneral: "Obecné",
    categoryTraining: "Školení",
    categoryPerformance: "Výkon",
    categoryBehavior: "Chování",
    categoryGoal: "Cíl",
  },
};
